module.exports = __webpack_public_path__ + "img/app_icon_31.fc41bdf9.png";